import React from 'react'
import { Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { required, password, maxLength, minLength } from '../../../utilities/validators'

const validate = () => {
  const errors = {}
  return errors
}

const [minLength6, maxLength20] = [minLength(6), maxLength(20)]

class ChangePasswordForm extends React.Component {
  render() {
    const { error, onSubmit, handleSubmit, userEmail } = this.props

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        method="post"
        aria-labelledby="change-password-heading"
      >
        {/* Hidden username field for password manager accessibility */}
        {userEmail && (
          <input
            type="text"
            name="username"
            value={userEmail}
            autoComplete="username"
            readOnly
            tabIndex={-1}
            aria-hidden="true"
            style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }}
          />
        )}
        <h4 id="change-password-heading">
          <FormattedMessage id="global.label.changePassword" />
        </h4>
        <div className="form-group">
          <Field
            component={renderField}
            dark
            validate={[required]}
            inputType="input"
            type="password"
            password
            name="password"
            label="global.label.oldPassword"
            autocomplete="current-password"
          />
          <Field
            component={renderField}
            dark
            validate={[required, minLength6, maxLength20, password]}
            inputType="input"
            type="password"
            password
            name="newPassword"
            label="global.label.newPassword"
            autocomplete="new-password"
          />
        </div>
        {error && (
          <div className="form-validation-error-message mb-2" role="alert" aria-live="polite">
            <FormattedMessage id={error} />
          </div>
        )}
        <Button
          name="changePasswordFormSubmitBtn"
          type="submit"
          outline
          color="light"
          block
          aria-describedby={error ? 'password-form-error' : undefined}
        >
          <FormattedMessage id="page.myAccountPage.button.newPassword" />
        </Button>
      </form>
    )
  }
}

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  userEmail: PropTypes.string,
}

export default reduxForm({
  form: 'changePasswordForm',
  validate,
})(ChangePasswordForm)
